import { useEffect, useState } from 'react';

const useModalAppearingAnimation = (show: boolean) => {
    const [showDefaultAnimation, setShowDefaultAnimation] = useState(false);

    useEffect(() => {
        if (show) {
            requestAnimationFrame(() => {
                setShowDefaultAnimation(true);
            });
        } else {
            setShowDefaultAnimation(false);
        }
    }, [show]);

    return { showDefaultAnimation };
};

export default useModalAppearingAnimation;
